import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calendario-table',
  templateUrl: './calendario-table.component.html',
  styleUrls: ['./calendario-table.component.css']
})
export class CalendarioTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
